<!-- eslint-disable prettier/prettier -->
<div class="rn-container">
	<!-- Panel izquierdo (info) -->
	<div class="rn-panel">
		<h1 class="rn-title">REGISTRATE EN<br />IDENTIDAD DIGITAL VL</h1>
		<p class="rn-desc">
			Necesitamos validar tu identidad con
			<strong>Renaper</strong>, el servicio de identidad digital de Argentina.
		</p>
		<ul class="rn-checklist" aria-label="Qué necesitás">
			<li>
				<lucide-icon name="circle-user" [size]="24" [strokeWidth]="2"></lucide-icon>
				<span>Tu cuenta de Mi Argentina / ANSES</span>
			</li>
			<li>
				<lucide-icon
					name="shield"
					[size]="24"
					[strokeWidth]="2"
					color="#131416"
				></lucide-icon>
				<span>Datos verificados por el Estado Nacional</span>
			</li>
		</ul>
	</div>

	<!-- Panel derecho -->
	<div class="rn-form-panel">
		@if (hasError) {
		<div class="rn-error">
			<lucide-icon
				name="circle-alert"
				[size]="24"
				[strokeWidth]="2"
				color="#131416"
			></lucide-icon>
			<span>No pudimos verificar tu identidad. Por favor, intentá nuevamente.</span>
		</div>
		}

		<p class="rn-desc rn-desc--action">
			Al continuar serás redirigido a <strong>Autenticar.gob.ar</strong> para verificar tu
			identidad. Una vez completado, volverás automáticamente.
		</p>

		<button type="button" class="rn-btn" (click)="iniciarAutenticacion()">
			Validar mi identidad
		</button>

		<p class="rn-login">
			¿Ya tenés una cuenta?
			<a [href]="inicioURL" (click)="$event.preventDefault(); goToLogin()">Iniciá sesión</a>
			<br />
			<br />
			¿Necesitás ayuda para registrarte? <br />Revisá las
			<a [href]="faqURL" target="_blank">preguntas frecuentes</a>
		</p>
	</div>
</div>
